import { useCallback } from 'react';
import { applyGraphDiff, redoHistory, undoHistory } from 'Custom-Mindmap';
import { MindMapContext } from '../../Context/contex';
import useSaveGraphDiff from './useSaveGraphDiff';

// Undo/redo of the user's own edits (D-036): applies the step to the current map, then saves and broadcasts it.
const useUndoRedo = () => {
    const { history, setHistory, nodes, edges, setNodes, setEdges, setIsDocumentChanged } = MindMapContext();
    const save = useSaveGraphDiff();

    const step = useCallback((move) => {
        const result = move(history);
        if (!result) return;
        const next = applyGraphDiff({ nodes, edges }, result.diff);
        setHistory(result.history);
        setNodes(next.nodes);
        setEdges(next.edges);
        setIsDocumentChanged(true);
        save(result.diff, next);
    }, [history, nodes, edges, setHistory, setNodes, setEdges, setIsDocumentChanged, save]);

    return {
        undo: useCallback(() => step(undoHistory), [step]),
        redo: useCallback(() => step(redoHistory), [step]),
        canUndo: history.past.length > 0,
        canRedo: history.future.length > 0,
    };
};

export default useUndoRedo;
